import { monthSelectOptions } from 'KnmPackage/MainModule/constants/monthSelectOptions';

import { RenderFunc } from '../types/RenderFunc';

export const renderMonth: RenderFunc = item => {
  const { newValue, oldValue } = item;

  return {
    renderedOldValue: monthSelectOptions.find(option => option.value === oldValue)?.label || '',
    renderedNewValue: monthSelectOptions.find(option => option.value === newValue)?.label || '',
  };
};
